import { Module } from 'vuex'
import RootStateTypes from '../../interface'
import { XTXObject, XTXPram, UkeyUserInfo } from './XTXScoket';

const XTXModel: Module<XTXObject, RootStateTypes> = {
    namespaced: true,
    state: {
        xtxScoket: null,
        count: 0,
        curUserCertId: "",
        ukeyList: Array<UkeyUserInfo>(),
    },
    mutations: {
        initWebsocket(state) {
            // 如果已存在连接，先关闭
            if (state.xtxScoket != null) {
                try {
                    if (state.xtxScoket.readyState === WebSocket.OPEN || state.xtxScoket.readyState === WebSocket.CONNECTING) {
                        state.xtxScoket.close();
                    }
                } catch (e) {
                    console.warn('关闭旧连接时出错:', e);
                }
                state.xtxScoket = null;
            }

            // 改为：
            var url = "";
            var isDesktopApp = navigator.userAgent.indexOf('VBiddingDesktop') > -1;
            if (isDesktopApp) {
                // 桌面客户端：直接用 ws 避免自签名证书问题
                url = "ws://127.0.0.1:21051/xtxapp/";
            } else if ('https:' == document.location.protocol) {
                url = "wss://127.0.0.1:21061/xtxapp/";
            } else {
                url = "ws://127.0.0.1:21051/xtxapp/";
            }

            try {
                state.xtxScoket = new WebSocket(url);

                //建立连接
                state.xtxScoket.onopen = function () {
                    /*
                     * 连接成功
                     * */
                    console.log('WebSocket连接成功:', url)
                }

                state.xtxScoket.onerror = function (error) {
                    /*
                     * 通讯异常
                     * */
                    console.error('WebSocket连接错误:', error);
                    console.log('通讯异常,请检查证书助手环境')
                    // 延迟设置为null，避免在错误回调中立即清除
                    setTimeout(() => {
                        if (state.xtxScoket && state.xtxScoket.readyState !== WebSocket.OPEN) {
                            state.xtxScoket = null;
                        }
                    }, 100);
                }

                state.xtxScoket.onclose = function (event) {
                    /*
                     * 关闭连接时回调函数
                     * */
                    console.log('WebSocket连接已断开:', event.code, event.reason);
                    state.xtxScoket = null;
                }
            } catch (error) {
                console.error('创建WebSocket连接失败:', error);
                state.xtxScoket = null;
            }

        },
        webSocketCall(state, xtxPram: XTXPram) {
            if (state.xtxScoket == null) {
                return;
            }
            var sendArray = {
                'call_cmd_id': xtxPram.callCmdId,
                'CLSID': xtxPram.clsid,
                'xtx_func_name': xtxPram.methodName,
                'func': xtxPram.methodName,
                'param': xtxPram.argsArray,
                'URL': window.location.href
            };

            if (state.xtxScoket.readyState == WebSocket.OPEN) {
                var s = JSON.stringify(sendArray);
                console.log(s);
                state.xtxScoket.send(JSON.stringify(sendArray));
            } else {
                console.log("错误！无法连接到 WebSocket server：[" + state.xtxScoket.url + "]!!!WebSocket 状态码:" + state.xtxScoket.readyState);
            }
        },
        setUserList(state, val) {
            state.ukeyList = val;
        },
        setCurUserCertId(state, val) {
            state.curUserCertId = val;
        }
    },
    actions: {
        initWebsocket(context: any) {
            context.commit('initWebsocket')
        },
        webSocketCall(context: any, xtxPram: XTXPram) {
            context.commit('webSocketCall', xtxPram)
        },
        setUserList(context: any, val) {
            context.commit('setUserList', val)
        }
        ,
        setCurUserCertId(context: any, val) {
            context.commit('setCurUserCertId', val)
        }
    }

}
export default XTXModel;